import ShareSocialMedia from '@/components/core/shared/share.social.media'
import { Button } from '@/components/ui/atoms/button'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/atoms/card'
import VideoPlaceholder from '@/components/ui/molecules/video.placeholder'
import { cn } from '@/lib/client'
import type { IFreeContent } from '@/types/free.content'
import { ArrowUpRight, ShoppingBag } from 'lucide-react'

export default function FreeContentDetailsAditional({
  content,
  handleClick,
}: {
  content: IFreeContent
  handleClick: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) {
  return (
    <Card className={cn('border-b border-zinc-100 border-2 shadow-lg lg:w-96')}>
      {content.highlight.classes.url ? (
        <CardHeader className="p-0">
          <VideoPlaceholder
            url={content.highlight.classes.url}
            title={content.highlight.classes.title}
            img={content.highlight.classes.images.medium.url}
            width={380}
            height={260}
            className="rounded-t-md"
          />
        </CardHeader>
      ) : (
        <div />
      )}
      <CardContent className="flex flex-col items-start p-4 text-sm gap-1 border-b">
        {content.classes.title && (
          <h2 className="font-semibold text-lg">
            {content.highlight.classes.title}
          </h2>
        )}
        <div
          className="text-base leading-6"
          dangerouslySetInnerHTML={{
            __html: content.highlight.classes.description || '',
          }}
        />
        <Button variant={'link'} asChild className={cn('w-full')}>
          <a
            href={content.permanentLink}
            target="_blank"
            aria-label="Grupo exclusivo"
            rel="noreferrer"
          >
            Acessar grupo
            <ArrowUpRight className="ml-1 h-4 w-4" />
          </a>
        </Button>
      </CardContent>
      <CardContent className="px-4 py-4 border-b">
        <Button
          variant="outline"
          size={'sm'}
          className={cn('rounded-sm w-full')}
          onClick={handleClick}
        >
          <ShoppingBag size={18} className="mr-2" /> Cursos relacionados
        </Button>
      </CardContent>
      <CardFooter className="flex flex-col items-center text-center px-4 pt-4 text-sm gap-3">
        <strong>Compartilhe</strong>
        <ShareSocialMedia
          link={`https://www.direcaoconcursos.com.br/conteudo-gratuito/${content.slug}`}
          title={content?.name}
        />
      </CardFooter>
    </Card>
  )
}
